<div class="eb-product-variants-table-actions" [attr.data-cy]="'variant-' + (product | async)?.code">
  <eb-purchase-product
    [tabIndex]="tabIndex"
    [product]="(product | async)?.successor !== undefined && !(product | async)?.orderable ? (product | async)?.successor : (product | async)"
    [showQuantity]="false"
    [iconOnly]="true"
    [showSuccessor]="(product | async)?.successor !== undefined && !(product | async)?.orderable"
    (click)="stopParentFunction($event)"
  >
  </eb-purchase-product>

  <a
    [routerLink]="['/' + routeModel.fullProductPath + '/v/' + routeModel.code]"
    [tabIndex]="tabIndex"
    target="_blank"
    (click)="stopParentFunction($event)"
    class="eb-product-variants-table-actions__detail-link"
    [ngbTooltip]="'productVariantList.showDetails' | cxTranslate"
  >
    <span class="fa fa-external-link"></span>
  </a>
</div>
